function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

!function (t, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }

    return t === o ? e : t;
  } : "function" == typeof define && define.amd ? define(function () {
    return function (t, n, e, i, o) {
      for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
        t = t ? t[n[i]] : o;
      }

      return t === o ? e : t;
    };
  }) : t.dlv = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }

    return t === o ? e : t;
  };
}(this);